import Modal, {ModalSize} from "../../../../common/components/Modal";
import PageToolbar from "../../../../common/components/PageToolbar";
import { Stacker } from "~/common/components/Stacker/Stacker";
import {Button, LoadingButton} from "../../../../common/components/Button/Button";
import {fetchContractsOverview} from "../../../../Contracts/api/getContractsOverview";
import {navigateToProductContract} from "../../../../Contracts/utils";
import {useState} from "react";
import {decideLoadedStep, useAddToCartWizardContext} from "../AddToCartWizard";
import {Alert} from "~/common/m3/Alert/Alert";
import type {ProductDescriptor} from "~/feature/ProductDescriptor/v1/types";

interface Props {
  productDescriptor: ProductDescriptor;
}

export const ContractAvailableModal = ({ productDescriptor }: Props) => {
  const { t, getModalProps, setStep, closePopup, getCloseBtn } = useAddToCartWizardContext();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const modalProps = getModalProps();
  return (
    <Modal
      {...modalProps}
      size={ModalSize.MEDIUM}
      onClose={closePopup}
      noPadding={true}
      footerChildren={
        <PageToolbar
          noBottomSpace={true}
          left={getCloseBtn(t("close"))}
          right={
            <Stacker direction="row" gap={8}>
              <Button
                color={"secondary"}
                onClick={() => setStep(decideLoadedStep(productDescriptor))}
                clta-modal-child-marker="without-contract"
              >
                {t("popup.atc.btn.withoutContract")}
              </Button>
              <LoadingButton
                onClick={() => {
                  setLoading(true);
                  fetchContractsOverview()
                    .then((data) => navigateToProductContract(data, productDescriptor.base.designation))
                    .catch(() => {
                      setLoading(false);
                      setError(true);
                    });
                }}
                inFlight={loading}
                clta-modal-child-marker="with-contract"
              >
                {t("popup.atc.btn.fromContract")}
              </LoadingButton>
            </Stacker>
          }
        />
      }
      rootProps={{
        "clta-modal-parent-marker": "true",
        "clta-product-name": productDescriptor.base.designation,
        "clta-product-id": productDescriptor.base.sapMaterialNumber,
      }}
    >
      <div className={"scha__add-to-cart-popup__contract-question"}>
        {!error && <Alert severity={"info"}>{t("popup.atc.contractInfo")}</Alert>}
        {error && <Alert severity={"error"}>{t("popup.atc.contractError")}</Alert>}
      </div>
    </Modal>
  );
};
